export const FormStructure = (isEdit) => {
  return [
    {
      id: "1",
      type: "inputBox",
      title: "Customer Name",
      name: "name",
      required: true,
    },
    {
      id: "2",
      type: "inputBox",
      title: "GST No.",
      name: "GST",
      // required: true,
    },
    {
      id: "3",
      type: "inputBox",
      title: "Email ID",
      variant: "email",
      name: "email",
      // required: true,
    },
    {
      id: "4",
      type: "phone",
      title: "Mobile Number",
      maxLength: 12,
      name: "mobileNumber",

      // required: true,
    },
    // {
    //   id: "5",
    //   type: "select",
    //   title: "Payment Duration",
    //   name: "payment_duration",
    //   options: ["1 Month", "2 Month", "3 Month", "4 Month", "5 Month", "6 Month"],
    //   // required: true
    // },
    // {
    //   id: "6",
    //   type: "select",
    //   title: "Select Country",
    //   // size: "4",
    //   name: "country",
    //   options: ["Advertise 1", "Advertise 2"],
    // },
    {
      id: "5",
      type: "select",
      title: "Select State",
      // size: "4",
      name: "state",
      options: ["Advertise 1", "Advertise 2"],
    },
    {
      id: "6",
      type: "inputBox",
      title: "State Code",
      // size: "4",
      name: "state_code",
      disabled: true,
    },
    {
      id: "7",
      type: "select",
      title: "Select City",
      //   size: "",
      name: "city",
      options: ["Advertise 1", "Advertise 2"],
    },
    {
      id: "8",
      type: "inputBox",
      title: "Address",
      name: "address",
      required: true,
      // disabled: true
    },
    {
      id: "9",
      type: "inputBox",
      title: "Pincode",
      name: "pincode",

      maxLength: "6",
      regex: /^[0-9\s\&]/,
      // isCapitalise: true,
      // required: true,
    },

    {
      id: "10",
      type: "hr",
    },
    {
      id: "11",
      type: "headind_ad",
      title: "Delivery Address ",
    },
    {
      id: "12",
      type: "hr2",
    },
    {
      id: "13",
      type: "Checkbox",
      name: "contact_p",
      title: "same as above",
      forceBox: true,
      // handleChanges	 :(event)=>{

      // 	setContactName(event.target.checked)
      // }
    },
    {
      id: "14",
      type: "select",
      title: "Select Delivery State",
      // size: "4",
      name: "delivery_state",
      options: ["Advertise 1", "Advertise 2"],
    },
    {
      id: "15",
      type: "inputBox",
      title: "Delivery State Code",
      // size: "4",
      name: "delivery_state_code",
      disabled: true,
    },
    {
      id: "16",
      type: "select",
      title: "Select Delivery City",
      //   size: "",
      name: "delivery_city",
      options: ["Advertise 1", "Advertise 2"],
    },
    {
      id: "17",
      type: "inputBox",
      title: "Delivery Address",
      name: "delivery_address",
      required: true,
      // disabled: true
    },
    {
      id: "18",
      type: "inputBox",
      title: "Delivery Pincode",
      name: "delivery_pincode",

      maxLength: "6",
      regex: /^[0-9\s\&]/,
      // isCapitalise: true,
      // required: true,
    },

    {
      id: "19",
      type: "button",
      title: isEdit ? "Edit" : "Create",
    },
  ];
};
